"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HideableWearableCategory = void 0;
const wearable_category_1 = require("./wearable-category");
const validation_1 = require("../../../validation");
const body_part_category_1 = require("./body-part-category");
var HideableWearableCategory;
(function (HideableWearableCategory) {
    HideableWearableCategory.schema = {
        oneOf: [Object.assign({}, wearable_category_1.WearableCategory.schema), Object.assign({}, body_part_category_1.BodyPartCategory.schema)]
    };
    HideableWearableCategory.validate = (0, validation_1.generateLazyValidator)(HideableWearableCategory.schema);
})(HideableWearableCategory = exports.HideableWearableCategory || (exports.HideableWearableCategory = {}));
//# sourceMappingURL=hideable-category.js.map